module.exports = __webpack_public_path__ + "static/d6-publishing-9a98b6dfadbc98c87ab86a707d71eb64.png";